'use client';

import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import type { LeadFormId } from '@core/Entities/Leads/LeadFormId';

import type { LeadFormData } from './FormConfig.entity';

const defaultLeadFormData: LeadFormData = {
  title: undefined,
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  phone: undefined,
  postcode: undefined,
  message: undefined,
  phoneWithCountryCode: {
    countryCode: undefined,
    phone: undefined,
  },
  bookAppointment: { bookAppointmentTime: undefined, bookAppointmentDate: undefined },
  partExchange: {
    partExchangeRegistration: undefined,
    partExchangeMileage: undefined,
    partExchangeSendValuation: undefined,
  },
  financeQuote: { financeQuoteChecked: undefined, financeQuoteTcsChecked: undefined },
  multiLeadCheckboxes: {
    driftrockChkBox: undefined,
    oneClickChkBox: undefined,
    oneClickDriftrockChkBox: undefined,
  },
  reservationCheckbox: undefined,
  marketingOptIn: undefined,
  thirdPartyOptIn: {
    thirdPartyOptInText: undefined,
    thirdPartyOptInEmail: undefined,
    thirdPartyOptInPost: undefined,
  },
};

export const leadFormDataAtom = atomFamily((_formId: LeadFormId) =>
  atom<LeadFormData>(defaultLeadFormData),
);
